import { useEffect, useRef } from 'react';
import styles from './ReservoirHero.module.css';

export default function ReservoirHero() {
	const canvasRef = useRef(null);

	useEffect(() => {
		const canvas = canvasRef.current;
		if (!canvas) {
			return undefined;
		}
		const ctx = canvas.getContext('2d');
		let animationId;
		let time = 0;

		const resize = () => {
			const dpr = window.devicePixelRatio || 1;
			const width = canvas.offsetWidth;
			const height = canvas.offsetHeight;
			canvas.width = Math.max(1, Math.floor(width * dpr));
			canvas.height = Math.max(1, Math.floor(height * dpr));
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
		};

		resize();
		window.addEventListener('resize', resize);

		const purple200 = '#8A94F3';
		const getWidth = () => canvas.offsetWidth;
		const getHeight = () => canvas.offsetHeight;

		const animate = () => {
			time += 0.01;
			const width = getWidth();
			const height = getHeight();

			if (width === 0 || height === 0) {
				animationId = requestAnimationFrame(animate);
				return;
			}

			ctx.clearRect(0, 0, width, height);

			const streamY = height * 0.82;
			const numStreams = 5;

			for (let i = 0; i < numStreams; i += 1) {
				const offsetFactor = Math.abs(i - (numStreams - 1) / 2) / ((numStreams - 1) / 2);
				const yOffset = (i - (numStreams - 1) / 2) * 6;
				const opacity = 0.1 + (1 - offsetFactor) * 0.15;
				const lineWidth = 0.8 + (1 - offsetFactor) * 1;

				ctx.beginPath();

				const points = [];
				const segments = 100;

				for (let j = 0; j <= segments; j += 1) {
					const t = j / segments;
					const x = -20 + t * (width + 40);

					const wave1 = Math.sin(t * 3 + time * 2.5 + i * 0.4) * 8;
					const wave2 = Math.sin(t * 7 + time * 3.5 + i * 0.3) * 4;
					const wave3 = Math.sin(t * 12 + time * 4 + i * 0.2) * 2;

					const y = streamY + yOffset + wave1 + wave2 + wave3;
					points.push({ x, y });
				}

				if (points.length > 0) {
					ctx.moveTo(points[0].x, points[0].y);
					for (let j = 1; j < points.length - 1; j += 1) {
						const xc = (points[j].x + points[j + 1].x) / 2;
						const yc = (points[j].y + points[j + 1].y) / 2;
						ctx.quadraticCurveTo(points[j].x, points[j].y, xc, yc);
					}
				}

				ctx.strokeStyle = purple200;
				ctx.lineWidth = lineWidth;
				ctx.globalAlpha = opacity;
				ctx.stroke();
				ctx.globalAlpha = 1;
			}

			const numParticles = 10;
			for (let i = 0; i < numParticles; i += 1) {
				const t = ((time * 0.15 + i * 0.1) % 1);
				const x = -20 + t * (width + 40);
				const streamIdx = i % numStreams;
				const yOffset = (streamIdx - (numStreams - 1) / 2) * 6;

				const wave1 = Math.sin(t * 3 + time * 2.5 + streamIdx * 0.4) * 8;
				const wave2 = Math.sin(t * 7 + time * 3.5 + streamIdx * 0.3) * 4;
				const wave3 = Math.sin(t * 12 + time * 4 + streamIdx * 0.2) * 2;

				const y = streamY + yOffset + wave1 + wave2 + wave3;

				ctx.beginPath();
				ctx.arc(x, y, 1.5, 0, Math.PI * 2);
				ctx.fillStyle = purple200;
				ctx.globalAlpha = 0.25;
				ctx.fill();
				ctx.globalAlpha = 1;
			}

			animationId = requestAnimationFrame(animate);
		};

		animate();

		return () => {
			window.removeEventListener('resize', resize);
			cancelAnimationFrame(animationId);
		};
	}, []);

	return (
		<div className={styles.hero}>
			<div className={styles.background} />
			<canvas ref={canvasRef} className={styles.canvas} />
			<div className={styles.content}>
				<div className={styles.contentInner}>
					<p className={styles.eyebrow}>The Reservoir</p>
					<h1 className={styles.headline}>Innovation flows here.</h1>
					<p className={styles.subhead}>
                        Your central hub for data-driven insights and emerging capabilities.
					</p>
				</div>
			</div>
		</div>
	);
}
